module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image1c.d38ce2dd.webp";